import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import getXcolumnJson from "./xcolumn/list";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import ListSimpleArea from "@/pcomponents/common/crud/list/list_simple";

function WordInsideWriteMultyArea(props: any) {
  let myProps = {
    info_arr: [],
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    is_show_close_btn: true,
    close_btn_text: "닫기",
    ...props
  };
  const [info_arr, set_info_arr] = useState(myProps.info_arr);
  const [select_row_num_arr, set_select_row_num_arr] = useState([]);
  const user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  let select_stu_grade_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });
  xColumnArr.select_arr.a_stu_grade = select_stu_grade_arr;

  const [multy_write_data, set_multy_write_data] = useState({
    multy_key: "",
    multy_val: "",
    a_sort1: "",
    a_sort2: "",
  });
  const [sort1_arr, set_sort1_arr] = useState([]);
  const [sort2_arr, set_sort2_arr] = useState([]);

  let multy_write_value_type = "";
  if (xColumnArr.select_arr[multy_write_data.multy_key]) {
    multy_write_value_type = "select";
  } else if (multy_write_data.multy_key == "a_sort1") {
    multy_write_value_type = "sort";
  }

  useEffect(() => {
    get_sort_arr_by_ajax({
      s_type: "sort1",
      s_par_seq: "",
    });
  }, []);

  const get_sort_arr_by_ajax = (inData: any) => {
    let tmp_listOpt: any = {
      s_type: "sort1",
      s_par_seq: "",
      ...inData
    };

    let form_json_data: any = {
      ...tmp_listOpt,
      s_mcomp_seq: "1",
      s_par_id: "word_inside_sort",
      order_id: "a_order_num",
      is_paging: "",
    };

    if (form_json_data.s_type != "sort1") {
      if (strFunc.is_empty(form_json_data.s_par_seq)) {
        if (form_json_data.s_type == "sort2") {
          set_sort2_arr([]);
        }
        return false;
      }
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_sort/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (form_json_data.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
            if (multy_write_data.a_sort1) {
              let tmp_row_select_seq = "";
              for (let s_i = 0; s_i < response.data["data"]["info_arr"].length; s_i++) {
                let tmp_sort_row: any = response.data["data"]["info_arr"][s_i];
                if (tmp_sort_row.a_title == multy_write_data.a_sort1) {
                  tmp_row_select_seq = tmp_sort_row.a_seq;
                }
              }
              if (tmp_row_select_seq) {
                get_sort_arr_by_ajax({
                  s_type: "sort2",
                  s_par_seq: tmp_row_select_seq,
                });
              }
            }
          } else if (form_json_data.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const go_change_select_values = () => {
    let change_info_arr = [...info_arr];
    let change_key = multy_write_data.multy_key;
    let change_val = multy_write_data.multy_val;
    for (let i = 0; i < change_info_arr.length; i++) {
      let info: any = change_info_arr[i];

      if (strFunc.str_in_array(i, select_row_num_arr) != -1) {
        if (multy_write_value_type == "sort") {
          info["a_sort1"] = multy_write_data.a_sort1;
          info["a_sort2"] = multy_write_data.a_sort2;
        } else {
          info[change_key] = change_val;
        }

        change_info_arr[i] = info;
      }
    }

    set_info_arr(change_info_arr);
    set_multy_write_data({
      ...multy_write_data,
      multy_val: "",
      a_sort1: "",
      a_sort2: "",
    });
  };

  const save_info_by_ajax = () => {
    for (let i = 0; i < info_arr.length; i++) {
      let info = info_arr[i];
      if (strFunc.is_empty(info.a_title)) {
        alert("제목을 입력해 주세요.");
        return false;
      }
    }
    let w_info_arr = [...info_arr];
    for (let i = 0; i < w_info_arr.length; i++) {
      let info = w_info_arr[i];

      w_info_arr[i].a_mcomp_seq = user.comp_seq;
    }

    if (strFunc.is_empty(user.comp_seq)) {
      alert("로그인 필요.");
      myProps.closePopup();
      return false;
    }

    let form_json_data: any = {
      data_arr: info_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert("저장에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <div className='my_flex_center mt-2'>
        <button className='btn btn-sky'
          onClick={() => { save_info_by_ajax(); }}>저장</button>
        {myProps.is_show_close_btn &&
          <button className='btn btn-dark'
            onClick={() => { myProps.closePopup(); }} >{myProps.close_btn_text}</button>
        }
      </div>

      <div>
        일괄변경:

        <select className='row-input ml-1'
          name="multy_key"
          value={multy_write_data.multy_key}
          onChange={(e: any) => {
            set_multy_write_data({
              ...multy_write_data,
              multy_key: e.target.value,
              multy_val: "",
              a_sort1: "",
              a_sort2: "",
            });
          }}
          style={{ width: "100px" }} >
          <option value="">선택</option>
          {xColumnArr.x_column_list_arr.map((col_data: any, col_idx: number) => {
            return (
              <option key={col_idx} value={col_data.key}>{col_data.name}</option>
            );
          })}
        </select>

        <span className='ml-1'>
          {multy_write_value_type == "" &&
            <input type='text' className='row-input' name="multy_val"
              value={multy_write_data.multy_val}
              onChange={(e: any) => {
                set_multy_write_data({
                  ...multy_write_data,
                  multy_val: e.target.value,
                });
              }}
              style={{ width: "120px" }}
            />
          }
          {multy_write_value_type == "select" &&
            <select className='row-input' name="multy_val"
              value={multy_write_data.multy_val}
              onChange={(e: any) => {
                set_multy_write_data({
                  ...multy_write_data,
                  multy_val: e.target.value,
                });
              }}
              style={{ width: "120px" }}>
              <option value="">선택없음</option>
              {
                xColumnArr.select_arr[multy_write_data.multy_key].map((item: any, idx: number) => {
                  return (
                    <option key={idx} value={item.value}>{item.text}</option>
                  );
                })
              }
            </select>
          }
          {multy_write_value_type == "sort" &&
            <span>
              <select className='row-input' name="a_sort1"
                value={multy_write_data.a_sort1}
                onChange={(e: any) => {
                  set_multy_write_data({
                    ...multy_write_data,
                    a_sort1: e.target.value,
                  });
                  let tmp_sort1_seq = "";
                  for (let s_i = 0; s_i < sort1_arr.length; s_i++) {
                    let tmp_sort_row: any = sort1_arr[s_i];
                    if (tmp_sort_row.a_title == e.target.value) {
                      tmp_sort1_seq = tmp_sort_row.a_seq;
                    }
                  }
                  if (tmp_sort1_seq) {
                    get_sort_arr_by_ajax({
                      s_type: "sort2",
                      s_par_seq: tmp_sort1_seq,
                    });
                  } else {
                    set_sort2_arr([]);
                  }
                }}
                style={{ width: "100px" }}>
                <option value="">선택없음</option>
                {
                  sort1_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_title}>{item.a_title}</option>
                    );
                  })
                }
              </select>

              <select className='row-input ml-1' name="a_sort2"
                value={multy_write_data.a_sort2}
                onChange={(e: any) => {
                  set_multy_write_data({
                    ...multy_write_data,
                    a_sort2: e.target.value,
                  });
                }}
                style={{ width: "100px" }}>
                <option value="">선택없음</option>
                {
                  sort2_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_title}>{item.a_title}</option>
                    );
                  })
                }
              </select>
            </span>
          }
        </span>
        <button className='btn btn-sky ml-1'
          onClick={() => {
            go_change_select_values();
          }}
        >변경</button>
      </div>

      <div className='mt-1'>
        <ListSimpleArea
          xColumnArr={xColumnArr}
          infoArr={info_arr}
          setInfoArr={set_info_arr}
          is_grid={true}
          is_select_click_multy={false}
          select_row_num_arr={select_row_num_arr}
          set_select_row_num_arr={set_select_row_num_arr}
        ></ListSimpleArea>
      </div>
    </div>
  );
};
export default WordInsideWriteMultyArea;